import {useState,useEffect} from 'react'
import util from "../../../../utils/utils";
import { Markdown2Svg } from '@components/Markdown2Svg';
import {LoadingDiv } from '@components/LoadingDiv';
import ReactMarkdown from 'react-markdown';
import useGetFullPolicy from '../../hooks/useGetFullPolicy';
import useGetPolicyTimelineMindmap from '../../hooks/useGetPolicyTimelineMindmap';
import { Download, Share2, ChevronsUp} from 'react-feather';
import {MarkBtn} from '../MarkBtn';
import { ErrorBoundary } from '@components/ErrorBoundary/index';

export const FileContentModal = (props) => {
    // const {data,setRelativeFile, viewPolicy,input} = props;
    const {fileName,fileId,searchContent,highlight,setFileName,setMdTxt,getPdfAction,savedFoldListData,setMarkData} = props;
    const [upBtnVisible,setUpBtnVisible] = useState(false)
    const {getFullPolicyAction ,fullPolicyLoading} = useGetFullPolicy();
    const {getPolicyTimelineMindmapAction, policyTimelineMindmapLoading} = useGetPolicyTimelineMindmap();
    const [data,setData] =useState()
    const [viewPolicy, setViewPolicy] = useState()
    const [copied, setCopied] = useState(false)

    useEffect(()=>{
        if(fileName){
            viewFullPolicyAction(fileName)
        }
    },[fileName])
    const viewFullPolicyAction = (item) => {
        reset();
        getFullPolicyAction({policy_title:item,search_content:searchContent})
        .then(res=>{setData(res)});

        getPolicyTimelineMindmapAction({policy_title:item})
        .then(res=>{setViewPolicy(res)})

    }

    useEffect(()=>{
        document.getElementById('fileContentScrollDiv')?.addEventListener('click', function(event) {
            if(event.target.tagName === 'A') {
                reset();
                setFileName(event.target.id?.replace(/《|》/g, ""))
            }
          });
    },[])

    useEffect(()=>{
        document.getElementById("fileContentScrollDiv")?.addEventListener("scroll",e=>{
            util?.throttle(setUpBtnStatus(),1000)
        })
    },[])
    const setUpBtnStatus = () => {
        let scrollTop = document.getElementById("fileContentScrollDiv")?.scrollTop
        // console.log(scrollTop)
        if(scrollTop > 800){
            setUpBtnVisible(true)
        }else{
            setUpBtnVisible(false)
        }
    }


    const [index,setIndex] = useState(0)

    const scrollIntoHightLight = (type) => {
        let containerElement = document.getElementById('fileContentScrollDiv')
        let childElements = containerElement.getElementsByClassName('bg-yellow-200');
        childElements[index]?.scrollIntoView({behavior: "smooth",block: "center", inline: "nearest"});
        if(type === 'forward'){
            setIndex((index + 1) % data?.high_light.length)
        }else if(type === 'back'){
            setIndex((index - 1) % data?.high_light.length)
        }
    }
    const reset = () => {
        setIndex(0);
        document.getElementById('topAnchor').scrollIntoView()
    }
    const share = () => {
        const txt = `${process.env.REACT_APP_DOMAIN}/policy/share?fileName=${fileName}&searchContent=${searchContent}&from=${util.getUserName()}`
        util.copyTxt(txt)
        setCopied(true);
    }
    useEffect(()=>{
        if(copied){
            setTimeout(()=>{
                setCopied(false)
            },2000)
        }
    },[copied])

    return (
        <dialog id="my_policy_modal" className="modal">
            <div className="modal-box p-0 realtive w-[95vw] h-[95vh] max-w-[95vw] flex flex-col">
                <div id="topAnchor"></div>

                <div className="bg-white p-4 sticky top-0 z-10">
                    <div className={`flex space-between items-center`}>
                        {/* {highlight ? 
                        <div className='flex flex-1'>

                            <h2 className="card-title pl-4">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                                </svg>
                                检索关联：{data?.high_light?.length}处
                            </h2>
                            <button className='ml-6' style={{transform: 'scaleX(-1)'}} disabled={index===0} onClick={()=>{scrollIntoHightLight('back')}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:index === 0 ? 0.3 : 1}}>
                                    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                </svg>
                            </button>
                            <button className='mx-1' disabled={data?.high_light?.length ===0 } onClick={()=>{scrollIntoHightLight('forward')}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:data?.high_light?.length ===0 ? 0.3 : 1}}>
                                    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                </svg>
                            </button>
                        </div> : */}
                        <h2 className="card-title pl-4 mr-6 flex-1">{fileName}</h2>
                        {/* } */}

                        <div className='mr-6 pr-6'>
                            {/* <button className='ml-6'>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
                                </svg>
                            </button> */}
                            {
                                copied ? 
                                <button className="btn btn-sm ml-4 btn-disabled">
                                ✔️ 已复制
                                </button>
                                 :
                                <button className="btn btn-ghost btn-sm btn-secondary ml-4" onClick={()=>{share()}}>
                                    <Share2 size="15"/>
                                    分享
                                </button>
    
                                // <button className='ml-4' 
                                // onClick={()=>{share()}}
                                // >
                                //     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                //         <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
                                //     </svg>
                                // </button>
                            }
                        </div>

                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 mt-2"  onClick={()=>{reset()}}>✕</button>
                        </form>
                    </div>
                </div>

                <div className="overflow-auto p-2 pb-6 lg:px-8 lg:py-2 text-justify lg:flex lg:gap-6 flex-1">
                    <div  className='flex-1 border h-full flex flex-col relative'>
                        {upBtnVisible && <div id="back-to-top" className="absolute bottom-8 right-8 z-10">
                            <button className="btn btn-circle btn-outline bg-base-100" 
                                onClick={()=>{
                                    let element = document.getElementById("fileContentScrollDiv");
                                    element.scrollTo({
                                        top: 0,
                                        behavior: "smooth"
                                    })}
                                }
                            >
                                <ChevronsUp size="16"/>
                            </button>
                        </div>}

                        <div className="flex space-between items-center p-4 bg-base-200 ">
                            <h2 className="card-title flex-1">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                                </svg>

                                原文内容:
                            </h2>
                            <div className='flex items-center gap-1'>
                                {highlight  && <div className='flex flex-1'>
                                    <h2 className="pl-4">
                                        检索关联：{data?.high_light?.length}处
                                    </h2>
                                    <button className='ml-6' style={{transform: 'scaleX(-1)'}} disabled={index===0} onClick={()=>{scrollIntoHightLight('back')}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:index === 0 ? 0.3 : 1}}>
                                            <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                    <button className='mx-1' disabled={data?.high_light?.length ===0 } onClick={()=>{scrollIntoHightLight('forward')}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:data?.high_light?.length ===0 ? 0.3 : 1}}>
                                            <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>}

                                <MarkBtn
                                    savedFoldListData={savedFoldListData}
                                    source_id={fileId}
                                    setMarkData={setMarkData}
                                />
                                <button className="btn btn-ghost btn-sm btn-ghost btn-secondary" 
                                onClick={()=>getPdfAction({policy_info:[{policy_title:fileName,policy_id:fileId}]})}
                                >
                                    <Download size="15"/>
                                    下载
                                </button>
                            </div>

                        </div>
                        <div id='fileContentScrollDiv' className='p-6 flex-1 overflow-auto'>

                            {
                                fullPolicyLoading || !data ? 
                                <>
                                <LoadingDiv/>
                                </> :
                                <>
                                    {/* {
                                        data?.markdown_content ? 
                                        <div className='prose' style={{maxWidth:'none'}}>
                                            <ReactMarkdown children={data?.markdown_content} /> 
                                        </div>
                                        : */}

                                        <div className="policyContentDiv"
                                            // dangerouslySetInnerHTML={{ __html: data?.html_content }}
                                            dangerouslySetInnerHTML={{ __html: util.HighlightText(data?.html_content, data?.html_high_light) }}
                                        />
                                        {/* <div dangerouslySetInnerHTML={{ __html: data?.high_light ? 
                                        util.HighlightText(data?.full_policy ?? data?.txt_full_content, data?.high_light)
                                        : data?.full_policy ?? data?.txt_full_content }}>
                                        </div> */}


                                    {/* } */}
                                </>
                            }
                        </div>

                    </div>
                    {/* {viewPolicy?.policy_mind_map &&  */}
                    <div className='lg:w-1/3 h-full overflow-auto'>
                        <div className='border mb-6'>
                            <h2 className="card-title bg-base-200 p-4 border-b">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
                                </svg>
                               政策脉络 :
                            </h2>
                            <div className='relative p-4'>
                                {
                                    policyTimelineMindmapLoading || !viewPolicy ? 
                                    <>
                                    <LoadingDiv/>
                                    </> :
                                    <ErrorBoundary>
                                        <Markdown2Svg
                                        fileName={fileName}
                                        divHeight='38vh'
                                        setFileName={setFileName}
                                        setMdTxt={setMdTxt}            
                                        txt={viewPolicy?.policy_mind_map?.replace(/\>+/g, '-') ?? ''}
                                        />
                                    </ErrorBoundary>
                                }
                            </div>
                        </div>
                        <div className="border mb-6">
                            <h2 className="card-title bg-base-200 p-4 border-b">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                               政策时间线分析 :
                            </h2>
                            {
                                policyTimelineMindmapLoading || !viewPolicy ? 
                                <div className='p-4'>
                                    <LoadingDiv/>
                                </div> :
                                <>
                                {
                                    viewPolicy?.time_line && 
                                    <ul className={`timeline timeline-snap-icon max-md:timeline-compact timeline-vertical  p-4 my-timeline`}>
                                    {viewPolicy?.time_line?.map(item =>
                                        <li>
                                            <div className="timeline-middle">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v4.59L7.3 9.24a.75.75 0 0 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75Z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <div className="timeline-end mb-10">
                                                <time className="font-mono italic">{item?.policy_time?.split(' ')[0] ?? item?.policy_time}  {item?.from_organization}</time>
                                                <div className="text-lg font-black link link-primary" onClick={()=>{setFileName(item?.policy_title);reset()}}>{item?.policy_title}</div>
                                            </div>
                                            <hr/>
                                        </li>
                                    )}
                                    </ul>
                                }
                                </>
                            }
                        </div>

                    </div>
                    {/* } */}
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button onClick={()=>{reset()}}>close</button>
            </form>

        </dialog>
    )
}